import { createStart } from "@tanstack/react-start";

// Default to client-side rendering for every route. Individual routes opt in
// with `ssr: true` (or `'data-only'`). See TANSTACK_START_MIGRATION.md §1.3.
export const startInstance = createStart(() => ({
  defaultSsr: false,
}));

declare module "@tanstack/react-router" {
  interface Register {
    config: Awaited<ReturnType<typeof startInstance.getOptions>>;
  }
}
